// extracted by mini-css-extract-plugin
export default {"productDescription":"Lba-z","featuredDescription":"Mba-z","description":"Nba-z","more":"Oba-z","descriptionSku":"Pba-z"};